<div>
	<span class="font-normal" [ngClass]="{ 'text-[#c22d2d]': !isProductInStock }" *ngIf="allowPreOrder == '1'">
		{{ isProductInStock ? stockQuantity + " Packs available for pre-order" : "Out of stock" }}
	</span>
	<div class="font-bold" [ngClass]="{ 'text-[#c22d2d]': !isProductInStock }" *ngIf="allowPreOrder != '1'">
		<span class="in-stock" *ngIf="stockQuantity >= 26">In Stock</span>
		<span class="limited-stock" *ngIf="stockQuantity >= 11 && stockQuantity < 26">Limited Stock</span>
		<span class="low-stock" *ngIf="stockQuantity >= 1 && stockQuantity < 11">Low Stock</span>
	</div>
</div>